const yogaGoals = [
  {
    label: "Wellness",
    value: 1,
  },
  {
    label: "Strength &  Flexibility",
    value: 30,
  },
  {
    label: "PCOS",
    value: 3,
  },
  {
    label: "High BP & Diabetes",
    value: 7,
  },
  // {
  //   label: "Thyroid",
  //   value: 4,
  // },
  {
    label: "Prenatal care",
    value: 9,
  },
  // {
  //   label: "Postnatal care",
  //   value: 6,
  // },
  {
    label: "Back Strengthening",
    value: 27,
  },
  // {
  //   label: "Diabetes",
  //   value: 5,
  // },
  //{
  //  label: "Good Digestion",
  //  value: 16,
  //},
];

export default yogaGoals;

// const yogaGoalList = [
//   {
//     label: "PCOS",
//     value: "pcos",
//     slug: "yoga-for-pcos-49",
//     ranking: 0,
//     related_nutrition_goals: ["PCOS", "PCOS & Infertility"],
//     related_nutrition_goals_ids: [3, 15],
//     is_customer_goal: false,
//   },
//   {
//     label: "Prenatal Care",
//     value: "prenatal",
//     slug: "prenatal-yoga-and-breathwork-49",
//     ranking: 0,
//     related_nutrition_goals: ["Pre Natal"],
//     related_nutrition_goals_ids: [9],
//     is_customer_goal: false,
//   },
//   {
//     label: "Postnatal Care",
//     value: "postnatal",
//     slug: "postnatal-yoga-and-breathwork-49",
//     ranking: 0,
//     related_nutrition_goals: ["Post Natal"],
//     related_nutrition_goals_ids: [6],
//     is_customer_goal: false,
//   },
//   {
//     label: "Wellness",
//     value: "wellness",
//     slug: "yoga-for-wellness-49",
//     ranking: 0,
//     related_nutrition_goals: ["General"],
//     related_nutrition_goals_ids: [1],
//     is_customer_goal: false,
//   },
//   {
//     label: "Thyroid Management",
//     value: "thyroid",
//     slug: "yoga-for-thyroid-india-49",
//     ranking: 0,
//     related_nutrition_goals: ["Thyroid Disorders"],
//     related_nutrition_goals_ids: [4],
//     is_customer_goal: false,
//   },
//   {
//     label: "Hypertension Management",
//     value: "hypertension",
//     slug: "yoga-for-hypertension-india-49",
//     ranking: 0,
//     related_nutrition_goals: ["High Blood Pressure", "Hypertension"],
//     related_nutrition_goals_ids: [7, 17],
//     is_customer_goal: false,
//   },
//   {
//     label: "Diabetes Management",
//     value: "diabetes",
//     slug: "yoga-for-diabetes-49",
//     ranking: 0,
//     related_nutrition_goals: ["Diabetes"],
//     related_nutrition_goals_ids: [5],
//     is_customer_goal: false,
//   },
//   {
//     label: "Back Pain Management",
//     value: "back-pain",
//     slug: "yoga-for-pain-management-49",
//     ranking: 0,
//     related_nutrition_goals: ["Back Strengthening", "Back Pain"],
//     related_nutrition_goals_ids: [27, 18],
//     is_customer_goal: false,
//   },
//   {
//     label: "Strength & flexibility Management",
//     value: "strength-flexibility",
//     slug: "yoga-for-strength-and-flexibility-49",
//     ranking: 0,
//     related_nutrition_goals: ["Strength and Flexibility"],
//     related_nutrition_goals_ids: [30],
//     is_customer_goal: false,
//   },
// ];
